import { RewardsAccount } from "redmond";

const LIFESTYLE_ONLY_OVERRIDE_CARD_PRODUCTS = ["Spark Cash Plus"];

/**
 * Determines if we should make the lifestyle eligibility API call
 * Returns true only if:
 * 1. Tenant is corporate (capone-corporate)
 * 2. User has at least one lifestyle-eligible card (Spark Cash Plus)
 */
export const shouldCheckLifestyleEligibility = (
  isCorporate: boolean,
  rewardsAccounts: RewardsAccount[]
): boolean => {
  if (!isCorporate) {
    return false;
  }

  const hasLifestyleEligibleCard = rewardsAccounts.some((account) =>
    LIFESTYLE_ONLY_OVERRIDE_CARD_PRODUCTS.includes(account.productDisplayName ?? "")
  );

  return hasLifestyleEligibleCard;
};
